module.exports = __webpack_public_path__ + "img/trust-pilot-rating.f8a78e6.svg";